import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import api from "../../services/instance";

export const getUsersAPI = createAsyncThunk(
    "getUsersAPI",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getAllUsers(payload));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const getSingleUserAPI = createAsyncThunk(
    "getSingleUserAPI",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getSingleUser(id));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const UpdateUserStatusAPI = createAsyncThunk(
    "UpdateUserStatusAPI",
    async (data, { rejectWithValue }) => {
        const id = data?.id
        const status = data?.status
        try {
            const response = await api.post(endpoints.updateUserStatus(id, status));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false,
    singleUser: "",
    users: [],
    analytics: {
        total: 0,
        active: 0,
        pending: 0,
        blocked: 0,
    },
    pagination: {
        current_page: 1,
        total_pages: 1,
        total: 0,
        per_page: 10,
    }
}

const superAdminUserSlice = createSlice({
    initialState,
    name: "superAdminUserSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getUsersAPI.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getUsersAPI.fulfilled, (state, action) => {
            const usersData = action.payload.data.data.users;
            state.users = usersData.data;
            state.analytics = action.payload.data.data.analytics;
            state.pagination = {
                current_page: usersData.current_page,
                total_pages: usersData.last_page,
                total: usersData.total,
                per_page: usersData.per_page,
            };
            state.loading = false;
        });

        builder.addCase(getUsersAPI.rejected, (state, action) => {
            state.loading = false;
        });

        // GET SINGLE USER
        builder.addCase(getSingleUserAPI.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getSingleUserAPI.fulfilled, (state, action) => {
            state.singleUser = action.payload.data.data;
            state.loading = false;
        });

        builder.addCase(getSingleUserAPI.rejected, (state, action) => {
            state.loading = false;
        });
    }
});

export const { } = superAdminUserSlice.actions
export default superAdminUserSlice.reducer